import React, { useEffect, useState } from "react";
import { api, fmtCurrency } from "../lib/api";
import { PageHeader, VendorTag } from "../components/layout/AppLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Plus, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

const VENDORS = ["Cisco", "Fortinet", "Palo Alto", "F5", "Checkpoint"];

export default function Catalog() {
  const [devices, setDevices] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ vendor: "Cisco", model: "", category: "", list_price: 0, labor_days: 1, sku: "" });
  const [vendorFilter, setVendorFilter] = useState("all");

  const load = async () => setDevices((await api.get("/devices")).data);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/devices", form); toast.success("Device added"); setOpen(false); setForm({ vendor: "Cisco", model: "", category: "", list_price: 0, labor_days: 1, sku: "" }); load(); }
    catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete device?")) return; await api.delete(`/devices/${id}`); toast.success("Deleted"); load(); };

  const filtered = vendorFilter === "all" ? devices : devices.filter((d) => d.vendor === vendorFilter);

  return (
    <div>
      <PageHeader
        overline="Hardware Layer"
        title="Device Catalog"
        subtitle="Vendor SKUs, list prices, and standard labor days for accurate quoting."
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-device-btn" className="bg-[#FFC107] hover:bg-[#E5A906] text-[#0F1E38] font-mono uppercase tracking-wider text-xs"><Plus size={14} className="mr-2"/> Add Device</Button></DialogTrigger>
            <DialogContent className="bg-white border-slate-300 text-[#0F1E38]">
              <DialogHeader><DialogTitle>New Device</DialogTitle></DialogHeader>
              <div className="grid grid-cols-2 gap-4">
                <div><Label>Vendor</Label>
                  <Select value={form.vendor} onValueChange={(v) => setForm({...form, vendor: v})}>
                    <SelectTrigger className="bg-slate-50 border-slate-300 mt-1"><SelectValue/></SelectTrigger>
                    <SelectContent>{VENDORS.map(v => <SelectItem key={v} value={v}>{v}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div><Label>Category</Label><Input value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} className="bg-slate-50 border-slate-300 mt-1"/></div>
                <div className="col-span-2"><Label>Model</Label><Input data-testid="device-model" value={form.model} onChange={(e) => setForm({...form, model: e.target.value})} className="bg-slate-50 border-slate-300 mt-1"/></div>
                <div><Label>SKU</Label><Input value={form.sku} onChange={(e) => setForm({...form, sku: e.target.value})} className="bg-slate-50 border-slate-300 mt-1 font-mono"/></div>
                <div><Label>List Price ($)</Label><Input type="number" value={form.list_price} onChange={(e) => setForm({...form, list_price: parseFloat(e.target.value) || 0})} className="bg-slate-50 border-slate-300 mt-1 font-mono"/></div>
                <div className="col-span-2"><Label>Labor Days</Label><Input type="number" step="0.5" value={form.labor_days} onChange={(e) => setForm({...form, labor_days: parseFloat(e.target.value) || 0})} className="bg-slate-50 border-slate-300 mt-1 font-mono"/></div>
              </div>
              <DialogFooter><Button data-testid="save-device-btn" onClick={save} className="bg-[#FFC107] hover:bg-[#E5A906]">Save</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />

      <div className="mb-4">
        <Select value={vendorFilter} onValueChange={setVendorFilter}>
          <SelectTrigger data-testid="catalog-vendor-filter" className="max-w-[200px] bg-white border-slate-300"><SelectValue/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Vendors</SelectItem>{VENDORS.map(v => <SelectItem key={v} value={v}>{v}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {filtered.map((d) => (
          <div key={d.id} data-testid={`device-card-${d.id}`} className="tactical-card border border-slate-200 bg-white rounded-lg p-5">
            <div className="flex items-start justify-between">
              <VendorTag vendor={d.vendor} />
              <button data-testid={`device-del-${d.id}`} onClick={() => del(d.id)} className="text-slate-500 hover:text-red-400" style={{transition:"color 0.15s ease"}}><Trash size={14} /></button>
            </div>
            <div className="mt-3 font-display font-bold text-lg text-[#0F1E38] leading-tight">{d.model}</div>
            <div className="text-xs text-slate-500 mt-1">{d.category}</div>
            <div className="mt-3 pt-3 border-t border-slate-200 font-mono text-[11px] text-slate-500">SKU · {d.sku}</div>
            <div className="mt-3 flex items-baseline justify-between">
              <span className="font-mono font-bold text-xl text-[#0F1E38]">{fmtCurrency(d.list_price)}</span>
              <span className="text-xs text-slate-500 font-mono">{d.labor_days}d labor</span>
            </div>
          </div>
        ))}
      </div>
      {filtered.length === 0 && <div className="grid-bg py-20 text-center text-sm text-slate-500 rounded border border-slate-200">No devices in catalog.</div>}
    </div>
  );
}
